import * as React from "react"
import { Helmet } from "react-helmet"

export const Seo = ({ metaRobot, canonicalUrl, metaDescription, metaTitle }) => {
  return (
    <Helmet>
      <title>{metaTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      <meta name="robots" content={metaRobot || "index"} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  )
}
